import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


// API call for users-list
export const getusersList = createAsyncThunk("users/list", async (reqbody) => {

    // console.log("reqbody==>", reqbody);

    let req_body = {};
    req_body = { ...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/listingusers", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

// //////Api call for users multi-delete///////
export const getusersmultidelete = createAsyncThunk("users/multidelete", async (reqbody) => {
    let req_body = {};
    req_body = {_ids:reqbody};
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/deleteusermany", requestOptions);
    const respdata = await response.json();
    return respdata;
});


////////////////////////////////// Delete multiple product form Table //////////////////////////////////


// export const getusersmultidelete = createAsyncThunk("users/multidelete", async(reqbody) => {

//     let req_body = {};
//     req_body = reqbody;
//     const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(req_body)
//     };
//     const response = await fetch(process.env.REACT_APP_API_URL + "api/deleteusersmany", requestOptions);
//     const respdatafordelete = await response.json();

//     return respdatafordelete;
// });


// API call for users-multiedit
export const getusersmultiedit = createAsyncThunk("users/edit", async (reqbody) => {

    // console.log("reqbody==>", reqbody);

    let req_body = {};
    req_body = { ...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/updateusermany", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});
////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
// export const getusersmultiedit = createAsyncThunk("product/list/edit", async(reqbody) => {

//     let req_body = {};
//     req_body = reqbody;
//     const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(req_body)
//     };
//     const response = await fetch(process.env.REACT_APP_API_URL + "api/updateusermany", requestOptions);
//     const respdatafordelete = await response.json();

//     return respdatafordelete;
// });
///////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const usermanagestatusUpdate = createAsyncThunk("statusUpdateUserManagement", async (reqbody) => {

    let req_body = {};
    req_body = reqbody.editData;
    console.log("reqbody==", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api/onlystatusupdate", requestOptions);
    const respdataforstatusUpdate = await response.json();

    return respdataforstatusUpdate;
});

export const resetPassword = createAsyncThunk('users/resetpassword', async (reqBody) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqBody)
    }
    console.log("reqBody====>", reqBody)
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/forgotpassword`, requestOptions);
    const res = response.json();
    return res;
  })
  ///////////////// For Welcome MAil ////////////////////////////////////////

export const welcomeMail = createAsyncThunk('users/welcomemail', async (reqBody) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqBody)
    }
    console.log("reqBody====>", reqBody)
    const response = await fetch(`${process.env.REACT_APP_API_URL}api9/wcmail`, requestOptions);
    const res = response.json();
    return res;
  })

  ////////////////// For Welcome MAil ////////////////////////////////////////






const userManagment = createSlice({
    name: 'userManagment',
    initialState: {
        submitting: false,
        users: [],
        loading: false,
        submitted: false,
        message: null,
        usersList: [],
        successmsg: "",
        success: false,
        currentEditUserData: null
    },

    reducers: {

        setSuccessAfterSubmit(state, action) {
            state.success = false;
        },
        currentEditUserData(state, action) {
            state.currentEditUserData = action.payload
        },
        setMessagefterSubmit(state, action) {
            state.messageflag = false;
            state.message = null;
        }

    },
    extraReducers: {

        /// For GEt Users List
        [getusersList.rejected]: (state, action) => {
            state.loading = false;
        },
        [getusersList.pending]: (state, action) => {
            // console.log("action p", action)
            // state.usersList = [];
            state.loading = true;
        },
        [getusersList.fulfilled]: (state, action) => {
            // console.log("action f", action)
            if (action.payload.status === 'success') {
                // state.usersList = [...action.payload.results.res];
                state.usersList = [...state.usersList, ...action.payload.results.res];
                state.message = action.payload.status;
                // state.submitted = true;
                state.loading = false;

            }
        },

     


        //////////////////////////// Delete Multiple User ///////////////////////////////
        [getusersmultidelete.pending]: (state, action) => {

            state.loading = true;
        },
        [getusersmultidelete.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Deleted Successfully';
                state.success = true;
            }

        },
        [getusersmultidelete.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// update Multiple User ///////////////////////////////
        [getusersmultiedit.pending]: (state, action) => {

            state.loading = true;
        },
        [getusersmultiedit.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }

        },
        [getusersmultiedit.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        /////////////////////////// Edit Multiple Item ///////////////////////////////
        [usermanagestatusUpdate.pending]: (state, action) => {
            state.loading = true;
        },
        [usermanagestatusUpdate.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully'
                state.success = true;
                // state.success[action.meta.arg.tableId] = true;
            }
        },
        [usermanagestatusUpdate.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        [resetPassword.pending]: (state, action) => {
        },
        [resetPassword.fulfilled]: (state, action) => {
          state.loading = false;
          if (action.payload.status === 'success') {
            state.users= action.payload.result
           
          }
          state.message = action.payload.message;  
          state.messageflag =true;
    
        },
        [resetPassword.rejected]: (state, action) => {
        },

        [welcomeMail.pending]: (state, action) => {
        },
        [welcomeMail.fulfilled]: (state, action) => {
          state.loading = false;
          if (action.payload.status === 'success') {
            state.usersCount = action.payload.result
           
          }
          state.message = action.payload.message;  
          state.messageflag =true;
    
        },
        [welcomeMail.rejected]: (state, action) => {
        },

        


    }
})

export default userManagment.reducer;
export const { setSuccessAfterSubmit, currentEditUserData } = userManagment.actions;


